<template>
    <div>
        <div class="container" style="width:100%;">            
             <el-form :model="editForm" inline >
                <el-row v-if="curItem" type="flex" style="margin-top:0px;" align="center">
                    <el-form-item label="终端客户">
                        {{curItem.终端客户}}
                    </el-form-item>
                    <el-form-item label="产品名称">
                        {{curItem.产品名称}}
                    </el-form-item>
                </el-row>
                
                <el-divider content-position="left" style="margin-top:0px;"><span style="font-size:larger;"></span></el-divider>

                <el-row>
                    <el-form-item label="跟进日期" style="width: 500px;">
                            <el-date-picker
                                    v-model="editForm.dateArray"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-M-d"
                                    start-placeholder="年/月/日"
                                    end-placeholder="年/月/日">
                            </el-date-picker>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="是否经销商任务">
                        <el-checkbox v-model="editForm.isAgent">是</el-checkbox>
                    </el-form-item>
                    <el-form-item v-if="editForm.isAgent" label="经销商名称">
                        <el-select v-model="editForm.agentId" filterable  style="width:300px" @change="onClientChange" placeholder="请选择">
                            <el-option v-for="item in agentDictList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="终端客户">
                        <el-select v-model="editForm.companyId" filterable clearable style="width:300px" @change="onClientChange" placeholder="请选择">
                            <el-option v-for="item in clientDictList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="客户订单">
                        <el-select v-model="editForm.orderId" clearable   style="width:600px" placeholder="请选择">
                            <el-option v-for="item in orderDicList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>  
                <el-row>
                    <el-form-item label="服务阶段">
                        <el-select v-model="editForm.seg" style="width:300px" placeholder="请选择">
                            <el-option v-for="item in segList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务类型">
                        <el-select v-model="editForm.serviceTypeId" style="width:300px" placeholder="请选择">
                            <el-option v-for="item in serviceTypeList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>                            
                </el-row>
                <el-row>
                    <el-form-item label="服务主题">
                        <el-input v-model="editForm.topic" class="text-width"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="服务内容">
                        <el-input v-model="editForm.content" size="medium" :rows="8" type="textarea"
                            autocomplete="off" placeholder="请输入服务内容" style="width:800px"
                            ></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="备注">
                        <el-input v-model="editForm.remark" size="medium" :rows="8" type="textarea"
                            autocomplete="off" placeholder="" style="width:800px"
                            ></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <my-upload-file-form-item v-model="editForm.sampleArr" label="附件" :limit="10" />
                </el-row>                  
            </el-form>
            <div slot="footer" style="display:flex;justify-content:center;margin-top:20px;">
                <el-button @click="close">关闭</el-button>
                <el-button style="margin-left:20px;" type="primary" @click="onSavePlan">保存</el-button>
            </div> 

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";
import {ZC_FinishPlan} from "@/api/zc";
import { getToken } from "@/utils/auth";
import {getSampleArrayFromSever,getSampleLogStrToSever} from "@/utils/tools";
import {ZC_SavePlan} from "@/api/zc";
import { getLatestMonthDateArrayByDate,getNextAndBeforeHalfYearDateArray } from "@/utils/time";

export default {
    name: 'baseform',
    props: ['curItem'],
    components: {
        MyUploadFileFormItem
      },
    computed: {
        ...mapGetters(['clientDictList','agentDictList','resultList','provideList','segList','serviceTypeList','clientOrderList'])
    },
    data() {
        return {
            orderDicList:[],
           editForm:{
                id:'',
                dateArray:getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'}),
                companyId:'',
                orderId:'',
                seg:'',
                serviceTypeId:'',
                topic:'',
                content:'',
                provideTypeArr:[],
                remark:'',
                sampleArr:[],
                isAgent:false,
                agentId:'',
            },
        };
    },

    async mounted() {
        this.init();
       
    },


    methods: {
        init(){
            if (!this.curItem){
                this.editForm.id='';
                this.editForm.dateArray=getLatestMonthDateArrayByDate({date:new Date(),delayNum:1, formatValue: 'yyyy-MM-dd'});
                this.editForm.companyId='';
                this.editForm.orderId='',
                this.editForm.seg='';
                this.editForm.serviceTypeId='';
                this.editForm.topic='';
                this.editForm.content='';
                this.editForm.provideTypeArr=[];
                this.editForm.remark='';
                this.editForm.sampleArr=[];
                this.editForm.isAgent=false;
                this.editForm.agentId='';
            }else{
                this.editForm=JSON.parse(JSON.stringify(this.curItem));
                this.editForm.dateArray=[this.curItem.planSDate,this.curItem.planEDate];
                this.editForm.provideTypeArr=[];
                var samples = this.curItem.samples;
                this.onClientChange().then(()=>{                    
                    this.editForm.orderId=this.curItem.orderId;
                })
                // console.log('aa',item,samples)
                this.editForm.sampleArr=getSampleArrayFromSever({samples});
            }
        },

        close(){
            this.$emit('close');
        },

        async onSaveDo(){
          
            this.$message.success('保存成功');
            this.$emit("onHaveDone");

        },

        async onClientChange(){
            const {companyId} = this.editForm;
            this.editForm.orderId='';
            await this.$store.dispatch("zc/clientOrderList", {
                clientIds:companyId,                
            }).then(res=>{
                this.orderDicList=[];
                this.clientOrderList.forEach(ele=>{
                    this.orderDicList.push({value:ele.id,label:ele.订单编号+'|'+ele.订单项次+':'+ele.产品名称+'('+ele.数量+')'})
                })               
                console.log('aa',this.orderDicList)
            });
        },

        async onSavePlan(){
            const {id,dateArray:[sDate,eDate],isAgent,agentId,companyId,orderId,seg,serviceTypeId,topic, content,remark,sampleArr} = this.editForm;
            if (!sDate) {
                this.$message.warning('请选择执行日期')
                return;
            }
            if (!isAgent && !companyId) {
                this.$message.warning('请选择终端客户')
                return;
            }
            if (isAgent && !agentId) {
                this.$message.warning('请选择经销商')
                return;
            }
            if (!seg ) {
                this.$message.warning('请选择服务阶段')
                return;
            }
            if (!serviceTypeId ) {
                this.$message.warning('请选择服务类型')
                return;
            }
            if (!topic?.trim()) {
                this.$message.warning('请输入服务主题')
                return;
            }
            if (!content?.trim()) {
                this.$message.warning('请输入服务内容')
                return;
            }
            var samples = getSampleLogStrToSever({sampleArr})
            // console.log('aa',sampleArr,samples)
            await ZC_SavePlan({id,isAgent,agentId,companyId,orderId,seg,serviceTypeId,planSDate:sDate,planEDate:eDate,topic,content,remark,samples});
            this.$message.success('保存成功');
            this.$emit("onHaveDone");
            // this.onQuery();
            // this.editDialogVisible=false;
        },

        
    }
};
</script>

<style scoped>
</style>